// extracted by mini-css-extract-plugin
module.exports = {"gridVideos":"history_gridVideos__2pKqf","containerVideo":"history_containerVideo__2m_s6","cardVideo":"history_cardVideo__3STwR"};